import {
  React,
  Component,
  withRouter
} from 'imports/CommonImports';

import {
  Header,
  LeftDrawer,
} from 'imports/ComponentsImports';

import withWidth, {LARGE, SMALL} from 'material-ui/utils/withWidth';
import 'components/common/App.css';

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      navDrawerOpen: true,
      token: props.getCookie('token'),
      user: props.getCookie('user'),
      currentStage: props.getCookie('current_stage'),
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.width !== nextProps.width) {
      this.setState({navDrawerOpen: nextProps.width === LARGE});
    }
  }

  handleChangeRequestNavDrawer() {
    this.setState({
      navDrawerOpen: !this.state.navDrawerOpen
    });
  }

  render() {
    let { navDrawerOpen } = this.state;
    const paddingLeftDrawerOpen = 260;

    const styles = {
      header: {
        paddingLeft: navDrawerOpen ? paddingLeftDrawerOpen : 0
      },
      container: {
        margin: '80px 20px 20px 15px',
        paddingLeft: navDrawerOpen && this.props.width !== SMALL ? paddingLeftDrawerOpen : 0
      }
    };
    if(this.state.token){
      return (
          <div>
            <Header styles={styles.header}
              handleChangeRequestNavDrawer={this.handleChangeRequestNavDrawer.bind(this)}
              removeCookie={this.props.removeCookie}
              getCookie={this.props.getCookie}/>
            <LeftDrawer navDrawerOpen={navDrawerOpen} user={this.state.user} currentStage={this.state.currentStage}/>
            <div style={styles.container}>
              {this.props.children}
            </div>
          </div>
      );
    }
    return(
      <div>
      {this.props.children}
      </div>
    );
  }
}

export default withRouter(withWidth()(App));



// WEBPACK FOOTER //
// ./src/components/common/App.js